import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '24px',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
});

export default useStyles;
